import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useTranslation } from "react-i18next";
import {
  bestOfferSelector,
  fetchbestOffer,
} from '@slices/Promotions/bestOffer';

import PromotionCarousel from './PromotionCarousel';

const BestOffer = () => {
  const dispatch = useDispatch();
  const state = useSelector(bestOfferSelector);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    dispatch(fetchbestOffer());
  }, [dispatch]);

  if (state.bestOffer?.length > 0) {
    return (
      <PromotionCarousel
        items={state.bestOffer}
        viewText={t("CON_EXPLORE_BEST_OFFERS")}
        title='CON_BEST_OFFERS'
      />
    );
  } else {
    return <></>;
  }
};

export default BestOffer;
